// extracted by mini-css-extract-plugin
export default {"instrumentStatusText":"instrumentStatusText-rw55r","ready":"ready-i_sDH","busy":"busy-LRfvD","error":"error-Vc6jO"};